import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import AgGridDataTable from "../../shared/utilities/AgGridDataTable";
import { formatFacilityCode } from "../../shared/functions/Functions";
import SearchGridPagination from "./SearchGridPagination";
import usePrevious from "../../../hooks/usePrevious";

function SearchGrid(props) {
  const agGridRef = useRef();
  const [resultCount, setResultCount] = useState(0);
  const [rowData, setRowData] = useState([]);
  const [columnDefs, setColumnDefs] = useState([{ headerName: "", field: "" }]);
  const facilities = useSelector((state) => state.search);
  const prevFacilities = usePrevious(facilities);

  const toTitleCase = (str) => {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  };

  const customGridCells = [
    {
      columnName: "EPA_ID",
      cellRenderer: function (params) {
        if (params.value != null) {
          return (
            `<a href="/facility/${params.value}" target="_">` +
            params.value.toUpperCase() +
            "</a>"
          );
        }
      },
    },
    {
      columnName: "Facility_Name",
      cellRenderer: function (params) {
        if (params.value != null) {
          return params.value.toUpperCase();
        }
      },
    },
    {
      columnName: "Active",
      cellRenderer: function (params) {
        if (params.value === true) {
          return "YES";
        } else if (params.value === false) {
          return "NO";
        }
      },
    },
    {
      columnName: "Owner",
      // cellRenderer: function (params) {
      //   return toTitleCase(params.value);
      // },
    },
    {
      columnName: "Operator",
      // cellRenderer: function (params) {
      //   return toTitleCase(params.value);
      // },
    },
    {
      columnName: "Street",
      // cellRenderer: function (params) {
      //   return toTitleCase(params.value);
      // },
    },
    {
      columnName: "City",
      // cellRenderer: function (params) {
      //   return toTitleCase(params.value);
      // },
    },
    {
      columnName: "County",
      // cellRenderer: function (params) {
      //   return toTitleCase(params.value);
      // },
    },
    {
      columnName: "Fac_Latitude",
      label: "Latitude"
    },
    {
      columnName: "Fac_Longitude",
      label: "Longitude"
    },
  ];

  if (facilities.searchResults.length > 0) {
    // facilities.searchResults = facilities.searchResults.map((el) =>
    //   el.Active === "0" ? { ...el, Active: false } : { ...el, Active: true }
    // );
    facilities.searchResults = facilities.searchResults.map((el) => ({
      ...el,
      Facility_Types: formatFacilityCode(el.Facility_Type_Codes),
    }));
  }

  const setAgGrid = (data) => {
    let columnsArr = data[0];
    let colDefArr = [];
    let columnsToHide = [
      "Facility_Type_Codes",
      // "Fac_Latitude",
      // "Fac_Longitude",
    ];
    let colDef = Object.keys(columnsArr).map((col) => {
      if (columnsToHide.includes(col)) {
        return;
      } else {
        if (customGridCells) {
          var cellRend = customGridCells.filter(
            (object) => object.columnName === col
          );
          if (cellRend.length > 0) {
            colDefArr.push({
              headerName: cellRend[0].label ? cellRend[0].label : col.replace(/_/g, " "),
              field: col,
              sortable: true,
              cellRenderer: cellRend[0].cellRenderer,
            });
          } else {
            colDefArr.push({
              headerName: col.replace(/_/g, " "),
              field: col,
              sortable: true,
            });
          }
        } else {
          colDefArr.push({
            headerName: col.replace(/_/g, " "),
            field: col,
            sortable: true,
          });
        }
      }
    });

    setColumnDefs(colDefArr);
    setRowData(data);
  };

  useEffect(() => {
    if (facilities.searchResults.length > 0 && prevFacilities !== facilities) {
      setResultCount(props.resultCount);
      setAgGrid(facilities.searchResults);
    }

    if (
      facilities.searchResults.length === 0 &&
      prevFacilities !== facilities &&
      facilities.isFetching === false
    ) {
      setRowData([]);
    }

    if (agGridRef.current) {
      if (facilities.isFetching === true) {
        agGridRef.current.api.showLoadingOverlay();
      } else if (
        facilities.searchResults.length === 0 &&
        prevFacilities !== facilities
      ) {
        setRowData([]);
        setResultCount(0);
        agGridRef.current.api.showNoRowsOverlay();
        agGridRef.current.columnApi.autoSizeAllColumns();
      } else if (rowData.length > 0) {
        agGridRef.current.api.hideOverlay();
      }
    }
  });

  useEffect(() => {
    var allColumnIds = [];
    agGridRef.current.columnApi.getAllColumns().forEach((column) => {
      allColumnIds.push(column.colId);
    });
    agGridRef.current.columnApi.autoSizeColumns(allColumnIds, false);
  }, [rowData && rowData.length > 0]);

  return (
    <React.Fragment>
      <div className="container m-t-md">
        <div>{resultCount ? resultCount : 0} Results</div>
        <AgGridDataTable
          agGridRef={agGridRef}
          columnDefs={columnDefs}
          rowData={rowData}
          initialPageSize={props.initialPageSize}
          pageTitle={"Search By"}
          hidePagination={true}
          hideCsvExport={true}
        />
        <SearchGridPagination
          onPageSizeChange={props.onPageSizeChange}
          onSortingChange={props.onSortingChange}
          onPageChange={props.onPageChange}
          queryParams={props.queryParams}
          resultCount={resultCount}
          filters={props.filters}
          results={props.results}
        />
      </div>
    </React.Fragment>
  );
}

export default SearchGrid;
